import React from 'react';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import i18n from '../../i18n';
import { ReactComponent as HelpRoundedIcon } from '../../static/images/svg/material-symbols_help-rounded.svg';
import './auxiliary-mode-toolbar-toggle.scss';

/** 顶栏「辅助模式」开关 Props：与各模块 auxiliary Context 中的布尔一致 */
export interface AuxiliaryModeToolbarToggleProps {
    /** 辅助模式是否已开启 */
    enabled: boolean;
    /** 点击整块区域时切换开/关 */
    onToggle: () => void;
}

/**
 * 云 RBP 顶栏「辅助模式」入口：整块可点切换；开启与关闭时外观一致，主文案区分状态。
 */
export function AuxiliaryModeToolbarToggle({ enabled, onToggle }: AuxiliaryModeToolbarToggleProps): JSX.Element {
    return (
        <ButtonBase
            component="div"
            disableRipple
            className="auxiliary-mode-toolbar-toggle"
            aria-pressed={enabled}
            aria-label={
                enabled
                    ? i18n.t('sub_function_page_text_auxiliary_mode_label_on')
                    : i18n.t('sub_function_page_text_auxiliary_mode_label_off')
            }
            onClick={onToggle}
        >
            <Stack direction="row" alignItems="center" spacing={1} className="auxiliary-mode-toolbar-toggle__inner">
                <Box className="auxiliary-mode-toolbar-toggle__icon-wrap" aria-hidden>
                    <HelpRoundedIcon className="auxiliary-mode-toolbar-toggle__icon" aria-hidden />
                </Box>
                <Box className="auxiliary-mode-toolbar-toggle__text">
                    {/* 设计稿 1834:50119：主副文案均为正文 20/24 Medium */}
                    <Typography variant="body1" className="auxiliary-mode-toolbar-toggle__title">
                        {enabled
                            ? i18n.t('sub_function_page_text_auxiliary_mode_label_on')
                            : i18n.t('sub_function_page_text_auxiliary_mode_label_off')}
                    </Typography>
                    <Typography variant="body1" component="p" className="auxiliary-mode-toolbar-toggle__sub">
                        {i18n.t('sub_function_page_text_auxiliary_mode_hint')}
                    </Typography>
                </Box>
            </Stack>
        </ButtonBase>
    );
}
